module.exports = __webpack_public_path__ + "static/media/ICON_LENS_CARE.852aa302.svg";